/* All page copy lives here so it can be edited without touching layout. */

export const CONTACT_EMAIL = 'natalya@vitalityvf.com';

/* Intake forms (ClickUp). Both confirmed. */
export const FOUNDER_FORM_HREF =
  'https://forms.clickup.com/9013492263/f/8ckxyh7-6653/VEIG11FRLDONDZ4GJ9';
export const MENTOR_FORM_HREF =
  'https://forms.clickup.com/9013492263/f/8ckxyh7-6713/ZVK095HCAGZY3WVUWP';

export const TERRAIN = [
  {
    title: 'Invisible at the start.',
    body: 'The earliest nature-inspired companies are hard for funders to find, and harder to back.',
  },
  {
    title: 'Lost in translation.',
    body: "Patents, TRL, and lab milestones don't turn into investor language on their own.",
  },
  {
    title: 'Short on gap funding.',
    body: 'Money to get from the lab to a seed round is scarce.',
  },
  {
    title: 'Carrying everything else.',
    body: 'Legal, accounting, the website, and PR all take time away from the science.',
  },
];

export const BASECAMP = [
  {
    icon: 'compass',
    title: 'Get ready to raise.',
    body: 'We review your deck, sanity-check your model, and help you build a diligence-ready one-pager.',
  },
  {
    icon: 'route',
    title: 'Meet the right investors.',
    body: 'You get a matched list of seed funds, plus warm intros timed to your milestones.',
  },
  {
    icon: 'backpack',
    title: 'Lighten the load.',
    body: 'We connect you with vetted legal, accounting, and marketing help, and take on the odd jobs nobody else will.',
  },
] as const;

/* `url` is the company's own site, never a Vitality page. Logos pending. */
export type FounderPhoto = {
  name: string;
  src: string;
  /** Crop in slightly: hides stray edge artifacts in the source image. */
  zoom?: boolean;
};

export const FOUNDERS: {
  company: string;
  founders: string;
  location: string;
  line: string;
  url: string | null;
  photos: FounderPhoto[];
}[] = [
  {
    company: 'BOPA Precision Agriculture',
    founders: 'Sarah Hinkley',
    location: 'Colorado',
    line: 'Autonomous nano-tractors that help small and mid-size farmers restore soil without harmful pesticides.',
    url: 'https://barnowlag.com/',
    photos: [
      { name: 'Sarah Hinkley', src: 'https://cdn.magicpatterns.com/uploads/3BKB8h5rNtLwAXxoiiTq7U/Sarah_Headshot.jpg' },
    ],
  },
  {
    company: 'Mothership Materials',
    founders: 'Jo Marini',
    location: 'New York',
    line: 'Container-sized biomanufacturing that turns food and farm waste into valuable materials, without heat or chemicals.',
    url: 'https://www.mothershipmaterials.com/',
    photos: [
      { name: 'Jo Marini', src: 'https://cdn.magicpatterns.com/uploads/ev1cjyx99Yn2PFmmavU1FU/Jo_Headshot.jpg' },
    ],
  },
  {
    company: 'TierraSphere',
    founders: 'Marcela Flores',
    location: 'Mexico',
    line: 'A patented platform, built on the natural processes of the Ramón tree, that restores soil and locks away carbon.',
    url: 'https://www.tierrasphere.com/',
    photos: [
      { name: 'Marcela Flores', src: 'https://cdn.magicpatterns.com/uploads/s3DymWXYg7vtaWJ2ddyGh4/Marcela_Headshot.jpg' },
    ],
  },
  {
    company: 'ReefCycle',
    founders: 'Mary Lempres & Shannon Parker',
    location: 'North Carolina',
    line: 'Cement made at room temperature by mimicking how shells and reefs build themselves.',
    url: 'https://reefcycle.earth/',
    photos: [
      { name: 'Mary Lempres', src: 'https://cdn.magicpatterns.com/uploads/wivWGWpwMsTBHNGbPSeQwu/Mary_Headshot.jpg' },
      {
        name: 'Shannon Parker',
        src: 'https://cdn.magicpatterns.com/uploads/nkEhtg3wCvZPpG1gDwMn96/Shannon_Headshot.jpg',
        zoom: true,
      },
    ],
  },
];
